export const PRIVACY_POLICY_URL =
  document.getElementById('account-app')?.dataset.privacyPolicyUrl || '#';
